module.exports = __webpack_public_path__ + "img/ywc.9fed1fc9.png";